module.exports = __webpack_public_path__ + "static/images/monet/background_time_picker.gif";